import React from 'react';
import TourExecuteManualTemplate from '../templates/Tourexecutemanualtemplate';
import useFetch from '../../hooks/useFetch';

function TourExecuteManualFirstPage(props) {
    const masterId = props.match.params.masterId;
    const tour = props.match.params.tour
    const accessToken = localStorage.getItem('accessToken');
    
    const delivery = useFetch(`${process.env.REACT_APP_API}/movement/forscanprd/${masterId}`, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + accessToken
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer'
    });
    
    return tour && delivery &&  (
        <>
            <TourExecuteManualTemplate delivery={delivery} tour={tour}/>
        </>
    )
}


export default TourExecuteManualFirstPage;